import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Square, Volume2 } from 'lucide-react';

const synth = typeof window !== 'undefined' ? window.speechSynthesis : null;

// Markdown out, so the voice reads words and not symbols.
const plain = (md) => (md || '')
  .replace(/```[\s\S]*?```/g, ' ')
  .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
  .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
  .replace(/[*_`#>|~]/g, '')
  .replace(/^\s*[-+]\s+/gm, '')
  .replace(/\s+/g, ' ')
  .trim();

/** Read an answer aloud with the browser's voice, in the app's language. */
const SpeakButton = ({ text }) => {
  const { t, i18n } = useTranslation();
  const [speaking, setSpeaking] = useState(false);
  const mine = useRef(null);  // the utterance this button started
  // Leaving the chat stops this answer's voice (and only this one's).
  useEffect(() => () => { if (mine.current && synth?.speaking) synth.cancel(); }, []);
  if (!synth) return null;
  const toggle = () => {
    if (speaking) { synth.cancel(); mine.current = null; setSpeaking(false); return; }
    synth.cancel();
    const u = new SpeechSynthesisUtterance(plain(text));
    u.lang = i18n.language;
    u.onend = () => { if (mine.current === u) mine.current = null; setSpeaking(false); };
    u.onerror = u.onend;
    mine.current = u;
    setSpeaking(true);
    synth.speak(u);
  };
  return (
    <button type="button" onClick={toggle} title={t(speaking ? 'bots.chat.speak_stop' : 'bots.chat.speak')}
      className={`p-1 rounded hover:bg-accent hover:text-foreground ${speaking ? 'text-amber-500' : ''}`} data-testid="answer-speak">
      {speaking ? <Square className="w-3 h-3 fill-current" /> : <Volume2 className="w-3.5 h-3.5" />}
    </button>
  );
};

export default SpeakButton;
